import nodeDescriptions from '../constants/nodeDescriptions';

export function getUrlForNodeDetails(nodeDetail, urlData) {
    const { description, extensionProperties } = nodeDetail;
    const urls = [];

    switch (description) {
        case nodeDescriptions.load:
            urls.push(
                urlData.flightDetailsUri +
                    extensionProperties?.['FlightId']
            );
            urls.push(
                urlData.containerDetailsUri +
                    extensionProperties?.['ContainerId']
            );
            break;
        case nodeDescriptions.offload:
            urls.push(
                urlData.flightDetailsUri +
                    extensionProperties?.['FlightId']
            );
            urls.push(
                urlData.containerDetailsUri +
                    extensionProperties?.['ContainerId']
            );
            break;
        case nodeDescriptions.uldPositioning:
            urls.push(
                urlData.containerDetailsUri +
                    extensionProperties?.['ContainerId']
            );
            break;
        case nodeDescriptions.departure:
        case nodeDescriptions.arrival:
            urls.push(
                urlData.flightDetailsUri + extensionProperties?.['FlightId']
            );
            break;
        case nodeDescriptions.reflight:
            urls.push(
                urlData.flightDetailsUri + extensionProperties?.['OldFlightId']
            );
            urls.push(
                urlData.flightDetailsUri + extensionProperties?.['NewFlightId']
            );
            break;
        default:
            break;
    }

    return urls;
}
